function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#2B9D8B",
  fillRule: "nonzero",
  stroke: "#2B9D8B",
  strokeWidth: 0.65
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.17 2.7H12v1.315h1.491v2.474c0 2.173-1.824 3.942-4.067 3.942-2.243 0-4.068-1.769-4.068-3.942V4.015h1.446V2.7H4.678A.668.668 0 0 0 4 3.358v3.131c0 2.898 2.433 5.256 5.424 5.256 2.99 0 5.423-2.358 5.423-5.256V3.358a.668.668 0 0 0-.678-.657zM16.813 14.292v3.11c0 1.81-1.52 3.284-3.39 3.284-1.869 0-3.39-1.473-3.39-3.285V12.11H8.679v5.292c0 2.536 2.129 4.599 4.746 4.599 2.616 0 4.745-2.063 4.745-4.599v-3.109h-1.356z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.492 10.044c-1.384 0-2.51 1.09-2.51 2.43s1.126 2.431 2.51 2.431c1.383 0 2.508-1.09 2.508-2.43s-1.125-2.431-2.508-2.431zm0 3.547c-.636 0-1.153-.5-1.153-1.117 0-.615.517-1.116 1.152-1.116.636 0 1.153.5 1.153 1.116 0 .616-.517 1.117-1.153 1.117z"
})));

function SvgDoctorMicrophone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorMicrophone);
export default __webpack_public_path__ + "static/media/doctor_microphone.675178c5.svg";
export { ForwardRef as ReactComponent };